var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayHeaderBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 108,
    viewBox: "0 0 250 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2707 96.954C20.7186 111.952 38.0326 118.448 55.2332 121.564C60.0306 122.429 64.3979 124.881 67.6336 128.527C70.8692 132.173 72.7852 136.801 73.0737 141.667C74.9198 173.509 81.3479 209.898 96.4738 244.971C99.7224 252.495 110.994 250.254 111.092 242.069C111.366 218.954 108.456 194.471 114.988 174.056C115.181 173.426 115.574 172.875 116.109 172.488C116.643 172.101 117.289 171.9 117.949 171.913C152.535 172.983 207.038 160.446 222.103 129.407C225.517 122.362 217.604 115.152 210.931 119.253C186.046 134.552 153.624 144.464 139.156 120.063C138.098 118.2 137.74 116.02 138.146 113.916C138.553 111.813 139.697 109.923 141.373 108.589C158.885 95.2882 183.273 84.9759 193.03 68.3214C197.225 61.1704 189.215 53.06 182.038 57.2062C129.589 87.7066 64.6956 97.2966 18.634 86.5517C17.3037 86.2493 15.9135 86.3483 14.6394 86.8361C13.3653 87.324 12.2646 88.1787 11.4763 89.2923C10.6881 90.4058 10.2478 91.7281 10.2112 93.0919C10.1746 94.4557 10.5433 95.7998 11.2707 96.954Z",
    fill: "#FFE8E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4676 70.1741C71.3004 75.5968 74.7341 80.3364 79.3157 83.7677C83.8973 87.1989 89.4116 89.1605 95.1308 89.3937C100.85 89.6269 106.506 88.1207 111.351 85.0738C116.197 82.027 120.005 77.5826 122.273 72.3271C124.542 67.0717 125.163 61.252 124.056 55.6361C122.949 50.0201 120.165 44.8717 116.073 40.8702C111.98 36.8686 106.77 34.2019 101.13 33.2219C95.4907 32.242 89.6866 32.9947 84.4837 35.3809C78.1225 38.2983 73.0676 43.4687 70.2945 49.8941C67.5214 56.3195 67.2269 63.5443 69.4676 70.1741Z",
    fill: "#FFE8E3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5551 47.863C74.3695 52.9978 73.9614 58.5488 76.6322 60.1585C79.3031 61.7683 84.0007 58.9065 87.1781 53.7266C90.3555 48.5467 90.7802 43.0376 88.0976 41.4228C85.4151 39.808 80.7325 42.6832 77.5551 47.863Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayHeaderBg);
export default __webpack_public_path__ + "static/media/dayHeaderBG.1c0f9d0ae19f3b37f940c5c84c1c982a.svg";
export { ForwardRef as ReactComponent };